import { FC } from 'react'
import ReactCodeInput from '@acusti/react-code-input'
import { Button } from 'react-bootstrap'

import useLoadingDelay from 'hooks/useLoadingDelay'
import { isIOS } from 'share/utils/isiOs'
import { loadingSpinnerPortal } from 'components/atoms/LoadingSpinner'
import {
  CodeVerificationContainer,
  CodeVerificationNotes,
  CodeVerificationSend,
  CodeVerificationSubmit,
  iOSCodeInputStyle
} from 'components/atoms/InputFields/CodeVerification'

const style = !isIOS ? {} : iOSCodeInputStyle

interface CodeVerificationProps {
  onClick: () => void
  error?: string
  isLoading?: boolean
  onChange?: (value: string) => void
  sendAgain?: () => void
  timeoutMinutes?: number
  value?: string
}

const CodeVerification: FC<CodeVerificationProps> = ({
  error,
  isLoading = false,
  onChange,
  onClick,
  sendAgain,
  timeoutMinutes = 5,
  value
}) => {
  const loading = useLoadingDelay(isLoading)

  return (
    <>
      {loading && loadingSpinnerPortal()}
      <CodeVerificationContainer>
        <p>Please enter the verification code below.</p>
        {error && <p>{error}</p>}
        <ReactCodeInput
          autoFocus
          className={`ui-code-verification-inputs ${error && 'with-errors'}`}
          fields={6}
          inputMode='numeric'
          inputStyle={style}
          name='code-input'
          type='number'
          value={value}
          onChange={onChange}
        />
        <CodeVerificationNotes>
          Please verify within {timeoutMinutes} minutes.
        </CodeVerificationNotes>
        {sendAgain && (
          <CodeVerificationSend>
            Didn't get a code?{' '}
            <span
              role='button'
              onClick={sendAgain}
              data-testid='mfa-send-again-link'
            >
              Send it again
            </span>
          </CodeVerificationSend>
        )}
        <CodeVerificationSubmit>
          <Button onClick={onClick} data-testid='mfa-next-button'>
            Next
          </Button>
        </CodeVerificationSubmit>
      </CodeVerificationContainer>
    </>
  )
}

export default CodeVerification
